import React from 'react';
import PropTypes from 'prop-types';
import { schedule as schedulePropType } from 'lib/CustomPropTypes/TVE';

const Schedule = ({ block, items }) => {
  if (!items) return null;

  return (
    <div className={`${block}__schedule`}>
      {
        items && items.map((i) => (
          <div key={i.guid} className={`${block}__schedule-item`}>
            <span className={`${block}__schedule-item-time`}>{i.startTimeFormatted}</span>
            <span className={`${block}__schedule-item-title`}>{i.program.title}</span>
          </div>
        ))
      }
    </div>
  );
};

Schedule.propTypes = {
  block: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape(schedulePropType),
  ),
};

Schedule.defaultProps = {
  block: null,
  items: [],
};

export default Schedule;
